import { useEffect, useState } from "react";
import api from "../lib/api";
import { ScrollText, Zap, ListVideo, Type, Link2, Play, Trash2, Monitor } from "lucide-react";

const ICONS = {
  paired: Link2, instant_push: Zap, playlist_assigned: ListVideo,
  ticker_updated: Type, played: Play, removed: Trash2,
};

export default function Logs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const load = () => api.get("/logs").then((r) => setLogs(r.data));
    load();
    const i = setInterval(load, 6000);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="p-6 md:p-8">
      <h1 className="text-3xl font-display font-bold tracking-tight mb-1">Activity Logs</h1>
      <p className="text-sm text-muted-foreground mb-6">What played where and when</p>

      {logs.length === 0 ? (
        <div className="border border-dashed border-border rounded-md py-20 text-center">
          <ScrollText className="w-12 h-12 mx-auto text-muted-foreground/30 mb-4" />
          <p className="text-muted-foreground">No activity yet.</p>
        </div>
      ) : (
        <div className="bg-card border border-border rounded-md divide-y divide-border">
          {logs.map((l) => {
            const Icon = ICONS[l.action] || Monitor;
            return (
              <div key={l.id} data-testid={`log-${l.id}`} className="flex items-center gap-3 px-4 py-3">
                <div className="w-8 h-8 rounded bg-secondary flex items-center justify-center flex-shrink-0">
                  <Icon className="w-4 h-4 text-primary" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm">
                    <span className="font-medium">{l.tv_name}</span>
                    <span className="text-muted-foreground"> — {l.action.replace(/_/g, " ")}</span>
                    {l.detail && <span className="text-muted-foreground/70"> · {l.detail}</span>}
                  </p>
                </div>
                <span className="text-xs text-muted-foreground font-mono flex-shrink-0">
                  {new Date(l.timestamp).toLocaleString()}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
